import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_ACCOUNT_KEY } from '@teetsh/app/src/queries/eleves/useEleves';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useDeleteEleve() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['eleve']);
  const { mutateAsync } = useMutation({
    mutationFn: (eleveId: string) =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleves/${eleveId}`,
        { method: 'DELETE' },
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_ACCOUNT_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('eleve:messages.deleteError_one'),
      });
    },
  });
  return mutateAsync;
}
